import { useIsAuthenticated } from '@azure/msal-react';
import { getValidBigInt } from '../util/bigInt';

function pageName() {
  return window.location.pathname.split('/').pop();
}

function pageParamValue(paramName: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}

export function isPublicRoute() {
  const bigIntValue = getValidBigInt(pageParamValue('uid'));
  const reqIdValue = pageParamValue('reqId');
  const datasetLayoutId = Number(pageParamValue('DatasetLayoutId'));
  return (
    (pageName()?.toLowerCase() === 'lrp-quotes' && bigIntValue > 0) ||
    (pageName()?.toLowerCase() === 'upload' && reqIdValue) ||
    (pageName()?.toLowerCase() === 'layoutinfo' && datasetLayoutId > 0)
  );
}

export function useCasAuthenticated() {
  const isAuthenticated = useIsAuthenticated();
  const isWebuser = isPublicRoute();

  return {
    isWebuser,
    isAuthenticated: isAuthenticated && !isWebuser,
  };
}

/*
    PublicLrpQuotesPage - is valid LRPQuotes request
    ApiContextProvider - passes to axiosAuthInstance
        -> shouldn't change per page but does
        -> could get from acquireAuthToken
    CasRouter - is valid LRPQuotes request

    acquireAuthToken - needs JS check can't have hook
*/
